import { ProductResponse, OrderItemResponse, ProductType } from "src/app/core/services/payments-api-service";
import { CheckoutProduct } from "../step-four/product-card/product-card.component";
import { IUnicoProduct } from "src/app/services/cms-api.service";
import { UnikoServicesConfig, UnikoServiceTypes } from "src/app/services/payments-api.service";
import { EnvironmentInjector } from "@angular/core";
import { localizeRoute } from "src/app/shared/utilities/localizeRoutes";


const getCssClassName = (product: ProductResponse): string => {
  const { sku } = product;
  if (sku === '0001') {
    return 'basic';
  }
  if (sku === '0006') {
    return 'photography';
  }
  if (sku === '0005') {
    return 'exclusive';
  }
  return 'unknown';
};

const getLearnMore = (product: ProductResponse): boolean => {
  const { sku } = product;
  if (sku === '0006') {
    return true;
  }
  return false;
};

const getLearnMoreLink = (product: ProductResponse, envInjector?: EnvironmentInjector): string => {
  let rs = '/services';
  const unikoServiceConfig = UnikoServicesConfig.find(f => f.sku == product.sku)
  if (unikoServiceConfig) {
    if (unikoServiceConfig.type == UnikoServiceTypes.unikoPhotography 
      || unikoServiceConfig.type == UnikoServiceTypes.unikoExclusive) {
      rs += `/${UnikoServiceTypes[UnikoServiceTypes.photography]}`
    }
  }
  rs = localizeRoute(rs, envInjector!)
  return rs;
};



export const mapProductsToCheckoutProducts = (
  products: ProductResponse[],
  productsDetails: IUnicoProduct[],
  envInjector?: EnvironmentInjector
): CheckoutProduct[] => {
  return products
    .map((x) => {
      return {
        ...x,
        benefits: productsDetails.filter((p) => p.sku == x.sku)?.[0]?.benefits,
        description: productsDetails.filter((p) => p.sku == x.sku)?.[0]?.description,
        titleBanner: x.sku === '0005' ? 'Αποκλειστικότητα στο Uniko' : '',
        learnMore: getLearnMore(x),
        learnMoreLink: getLearnMoreLink(x, envInjector),
        cssClassName: getCssClassName(x),
        isSelected:false
      };
    })
    .filter((x) => x.sku === '0001' || x.sku === '0006' || x.sku === '0005')
    .sort((a, b) => {
      const order = ['0001', '0006', '0005'];
      return order.indexOf(a?.sku ?? '') - order.indexOf(b?.sku ?? '');
    });
};


export const mapOrderItemsToCheckoutProducts = (
  orderItems: OrderItemResponse[],
  productsDetails: IUnicoProduct[],
  envInjector?: EnvironmentInjector
): CheckoutProduct[] => {
  return orderItems.map((x) => {
    return {
      ...x,
      title: productsDetails?.filter(p => p.sku == x.sku)?.[0]?.title ?? x.title,
      discount: x?.discount,
      benefits: productsDetails?.filter(p => p.sku == x.sku)?.[0]?.benefits,
      description: productsDetails?.filter(p => p.sku == x.sku)?.[0]?.description,
      type: orderItems?.find(x => x.sku == x.sku)?.productType ?? ProductType.Unspecified,
      titleBanner: x.sku === '0005' ? 'Αποκλειστικότητα στο Uniko' : '',
      learnMore: getLearnMore(x),
      learnMoreLink: getLearnMoreLink(x, envInjector),
      cssClassName: getCssClassName(x),
      isSelected:false
    };
  })
};